



















































































import {
  CreateDocumentVariableModel,
  DocumentVariableModel,
  DocumentVariablesClient,
  UpdateDocumentVariableValueModel
} from "@/api/OtiumAppApi";
import { useEditorStore } from "@/stores/editorStore";
import { useProjectStore } from "@/stores/projectStore";
import { defineComponent, ref, watch } from "@vue/composition-api";
import VariableEditor from "../Editor/VariableEditor.vue";

export default defineComponent({
  components: { VariableEditor },
  props: {
    openedDialogs: {
      type: Object,
      required: true
    },
    editingVariable: {
      type: DocumentVariableModel
    }
  },
  setup(props, context) {
    const projectStore = useProjectStore();
    const editVariableValue = ref("");
    watch(
      () => props.editingVariable,
      (newValue) => {
        if (newValue) {
          editVariableValue.value = newValue.version.value;
        }
      }
    );

    const newVariableValue = ref("");
    const newVariableName = ref("");

    const savingNewVariable = ref(false);
    const saveNewVariable = async () => {
      if (!projectStore.documentVersionIdInContext) return;
      savingNewVariable.value = true;

      const client = new DocumentVariablesClient();
      await client.createVariable(projectStore.documentVersionIdInContext, {
        value: newVariableValue.value,
        name: newVariableName.value
      } as CreateDocumentVariableModel);

      const editorStore = useEditorStore();
      editorStore.insertVariable(newVariableName.value);

      savingNewVariable.value = false;
      props.openedDialogs.add = false;
      newVariableValue.value = "";
      newVariableName.value = "";
    };

    const savingEditVariable = ref(false);
    const saveEditVariable = async () => {
      if (!props.editingVariable) return;
      savingEditVariable.value = true;
      const client = new DocumentVariablesClient();
      await client.updateVariable(props.editingVariable.id, {
        value: editVariableValue.value
      } as UpdateDocumentVariableValueModel);

      savingEditVariable.value = false;
      props.openedDialogs.edit = false;
    };

    return {
      projectStore,
      editVariableValue,
      savingEditVariable,
      saveEditVariable,

      newVariableName,
      newVariableValue,
      savingNewVariable,
      saveNewVariable
    };
  }
});
